import React from 'react'
import { CabinetProduct } from '../../components/Cabinet'

class CabinetsProduct extends React.PureComponent {
  render() {
    const {
      productTitle,
      productSupervisoriesCode,
      removeButtonFunctionality,
      buttonAction,
      productProvider
    } = this.props
    return (
      <CabinetProduct
        productTitle={productTitle}
        productSupervisoriesCode={productSupervisoriesCode}
        productProvider={productProvider}
        removeButtonFunctionality={removeButtonFunctionality}
        buttonAction={buttonAction}
      />
    )
  }
}

export default CabinetsProduct



// WEBPACK FOOTER //
// ./src/containers/IncompatibilityAnalysis/CabinetsProduct.js